import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

export type DisplayMode = 'all' | 'bag';

export const useDisplayMode = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const displayMode = searchParams.get('display') ?? ('all' as DisplayMode);

    const setDisplayMode = useCallback(
        (displayMode: DisplayMode) => setSearchParams({ display: displayMode }),
        [setSearchParams],
    );
    return {
        displayMode,
        setDisplayMode,
    };
};
